import { render } from "./Laptop.vue?vue&type=template&id=5b770c5b"
import script from "./Laptop.vue?vue&type=script&lang=js"
export * from "./Laptop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__